import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import FormattedDateTextInput from './FormattedDateTextInput';
import JobInputTitle from './JobInputTitle';
import {convertDate} from '../shared/functions';
import {jobBuilderStyles} from '../shared/styles-job-builder';

class JobDateFromToInput extends Component {
    constructor(props) {
        super(props);
        const year = new Date().getFullYear();
        const dateToMax = new Date();
        const dateFromMin = new Date();
        const dateFromMax = new Date();
        dateFromMin.setFullYear(year - 10);
        dateFromMax.setDate(dateFromMax.getDate() - 1);

        this.state = {
            dateFromMax: dateFromMax,
            dateFromMin: dateFromMin,
            dateToMax: dateToMax,
            selectedEndDate: null,
            selectedEndDateObject: null,
            selectedStartDate: null,
            selectedStartDateObject: null
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.reset && !this.props.reset) {
            this.setState({
                selectedEndDate: null,
                selectedEndDateObject: null,
                selectedStartDate: null,
                selectedStartDateObject: null
            });
        }
    }

    // Convert date selection if needed
    getSelectedDateValue = (e) => {
        // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
        const dateStr = convertDate(e, 'query', false, true);
        // Date native types are "str" so far
        return (this.props.nativeType === 'str') ? dateStr : dateStr;
    };

    // Event: Handle Start Date selection and notify form
    handleStartDateSelect = (event, index, value) => {
        let dateValue = this.getSelectedDateValue(index);
        this.setState({
                selectedStartDate: dateValue,
                selectedStartDateObject: index
            }, () => {
                if (typeof this.props.onSelectDate === 'function') {
                    this.props.onSelectDate(this.props.customType, this.props.name, [dateValue, this.state.selectedEndDate]);
                }
            }
        );
    };

    // Event: Handle End Date selection and notify form
    handleEndDateSelect = (event, index, value) => {
        let dateValue = this.getSelectedDateValue(index);
        this.setState({
                selectedEndDate: dateValue
            }, () => {
                if (typeof this.props.onSelectDate === 'function') {
                    this.props.onSelectDate(this.props.customType, this.props.name, [this.state.selectedStartDate, dateValue]);
                }
            }
        );
    };

    render() {
        const {
            label,
            name,
            required,
            tooltip
        } = this.props;

        const {
            dateFromMin,
            selectedStartDateObject
        } = this.state;

        return (
            <Fragment>
                <JobInputTitle label={label} tooltip={tooltip}/>
                <div className="list-filter" style={jobBuilderStyles.dateFromToContainer}>
                    <FormattedDateTextInput
                        source={`${name}_from`}
                        name={`${name}_from`}
                        label={`Start Date${(required) ? ' *' : ''}`}
                        isRequired={required}
                        onChangeFunc={this.handleStartDateSelect}
                        minDate={(dateFromMin) ? dateFromMin : new Date()}
                    />
                    <FormattedDateTextInput
                        source={`${name}_to`}
                        name={`${name}_to`}
                        label={`End Date${(required) ? ' *' : ''}`}
                        isRequired={required}
                        onChangeFunc={this.handleEndDateSelect}
                        minDate={selectedStartDateObject}
                        isDisabled={(!selectedStartDateObject)}
                    />
                </div>
            </Fragment>
        )
    }
}

JobDateFromToInput.propTypes = {
    customType: PropTypes.string,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onSelectDate: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    reset: PropTypes.bool,
    tooltip: PropTypes.string
};

JobDateFromToInput.defaultProps = {
    defaultValue: '',
    name: 'date',
    param: 'date',
    nativeType: 'str',
    required: false,
    reset: false
};

export default JobDateFromToInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobDateFromToInput.js